/** The overlay section lives in `?settings=<group>/<section>`. */
export const SETTINGS_QUERY_KEY = 'settings';
